export default __webpack_public_path__ + "static/media/p15.968805c5.jpeg";